export const GET_MONITOR_LOCATIONS_IN_PROGRESS = "GET_MONITOR_LOCATIONS_IN_PROGRESS";
export const GET_MONITOR_LOCATIONS_SUCCESS = "GET_MONITOR_LOCATIONS_SUCCESS";
export const GET_MONITOR_LOCATIONS_FAILED = "GET_MONITOR_LOCATIONS_FAILED";
